import { IApiCounters, ICounters } from './counters.types';

export const countersSerializer = ({
  data: { attributes },
}: IApiCounters): ICounters => attributes;
